import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "hiq_admin_token";
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));

export const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errorText(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const SITE = "https://harvestportfolios.com";

export const money = (v, d = 2) => (v == null ? "—" : `$${Number(v).toFixed(d)}`);
export const distAmt = (v) => (v == null ? "—" : `$${Number(v).toFixed(4).replace(/0{1,2}$/, "")}`);
export const pct = (v) => (v == null ? "—" : `${Number(v).toFixed(2)}%`);
export const fee = (v) => (v == null || v === "" ? "—" : /^[\d.]+$/.test(v) ? `${Number(v).toFixed(2)}%` : v.replace(/^([\d.]+)/, "$1%"));
export const aum = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}M`);
